import request from '@/router/axios';
export const normalFlowableRebateAudit = (params) => {
  return request({
    url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-rebate-audit`,
    method: "post",
    data: {...params}
  });
}
